import React, { useEffect } from 'react'
import useNav from '../../../../hooks/useNav';
import { Link, useSearchParams } from 'react-router-dom';
import { Breadcrumb } from '../../../../components/ui/breadcrumb';
import { styles } from '../../../../styles/tailwind-config';

const Questionnaire = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { setNav, nav } = useNav()

    useEffect(()=>{
        setNav({...nav, title:`Vragenlijst - callid ${searchParams.get('callid')}`})
    }, [])

  return (
    <div className='p-4 flex flex-col gap-4'>
        <Breadcrumb items={[{title:<Link to={`/intervention/start?callid=${searchParams.get('callid')}`}>Interventie {searchParams.get('callid')}</Link>}, {title:<Link to={`/intervention/bezoekrapport?callid=${searchParams.get('callid')}`}>Bezoekrapport</Link>}, {title:<Link to="">Vragenlijst</Link>}]}/>
        <h1 className={`${styles.h1}`}>Vragenlijst</h1>
    </div>
  )
}

export default Questionnaire